import { company } from '~/company/Company';
import type { Offer } from '~/stores/CategoriesStore';

interface formatOptions {
  prefix?: string;
  defaultVolume?: string;
}

export const formatVolume = (
  properties: Offer['properties'],
  options?: formatOptions,
): string => {
  const { prefix, defaultVolume = company.config.defaultVolumeDisplay } =
    options || {};
  const { volume } = properties;

  if (!volume) {
    return company.match({
      mcosmetic: '',
      default: prefix ? `${prefix} ${defaultVolume}` : defaultVolume,
    });
  }

  let value: string = `${volume.value}`;

  if (Array.isArray(volume.value)) {
    value = `${volume.value[0]}`;
  }

  if (!prefix) {
    return value;
  }
  return `${prefix} ${value}`;
};

export const formatColors = (properties: Offer['properties']): string[] => {
  const { tsvet } = properties;
  if (!tsvet) return [];

  return tsvet.choices.map((choice) => `${choice.value}`);
};

export const pluralizePcLabel = (
  value?: number | string | null,
  label = 'x',
) => {
  return `${value}${label}`;
};
